import React from 'react';
import './HomeView.less';
import Modal from '@mui/material/Modal';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.less';
import 'slick-carousel/slick/slick-theme.less';
import SlideItem from '../../components/SlideItem/SlideItem';
import { homeWalkthrogh1, homeWalkthrogh2 } from '../../../assets/brandImages';
import {
  getVersionHeaderColor,
  LocalizePropType,
  isKYCApp,
  UserDataOutput,
} from 'getaway-data-layer';
import { GA_TITLES } from '../../../utils';
import BrandButton from '../../components/BrandButton/BrandButton';
import LanguageSelector from '../../components/LanguageSelector/LanguageSelector';

type Props = {
  localize: LocalizePropType;
  user: UserDataOutput;
  sliderIndex: number;
  sliderRef: any;
  onClickNext: () => void;
  onClickGuest: () => void;
  onClickLogin: () => void;
  afterSlide: (index: number) => void;
  onClickVersionHeader: () => void;
};

const HomeView = ({
  localize,
  user,
  sliderRef,
  sliderIndex,
  onClickGuest,
  afterSlide,
  onClickVersionHeader,
  onClickLogin,
  onClickNext,
}: Props) => {
  const settings = {
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    dotsClass: 'slick-dots home-slick-dots',
  };
  const open = !user && sliderIndex !== 2;
  const actions = (
    <>
      <div className="home-top-container">
        <div
          className="version"
          onClick={onClickVersionHeader}
          style={{ color: getVersionHeaderColor() }}
        >
          {localize('home.about')}
        </div>
        <LanguageSelector />
      </div>
      <div className={`home-bottom-container`}>
        <BrandButton
          id={GA_TITLES.AUTH.SIGN_UP}
          title={localize('home.button.title')}
          containerStyles={{ position: 'unset', width: '100%' }}
          onClick={onClickNext}
        />
        <div
          onClick={isKYCApp() ? onClickLogin : onClickGuest}
          className="signup-footnote"
        >
          <div
            data-testid="HomeView-footnoteText"
            className={`home-footnote-text ${
              !isKYCApp() ? 'home-footnote-action' : ''
            }`}
          >
            {localize(
              isKYCApp()
                ? 'signup.footnote.login.text'
                : 'home.walkthrough.guest'
            )}
          </div>
          {isKYCApp() && (
            <div
              data-testid="HomeView-loginBtn"
              className="home-footnote-action"
            >
              {localize('signup.footnote.login.action')}
            </div>
          )}
        </div>
      </div>
    </>
  );
  return (
    <Modal open={open} onClose={() => {}} hideBackdrop>
      <div>
        <Slider ref={sliderRef} {...settings} afterChange={afterSlide}>
          <SlideItem
            titleTestId="HomeView-title"
            descriptionTestId="HomeView-description"
            title={localize(`home.walkthrough.page1.title`)}
            description={localize(`home.walkthrough.page1.description`)}
            imageSrc={homeWalkthrogh1}
            extraComponents={actions}
          />
          <SlideItem
            titleTestId="HomeView-title"
            descriptionTestId="HomeView-description"
            title={localize(`home.walkthrough.page2.title`)}
            description={localize(`home.walkthrough.page2.description`)}
            imageSrc={homeWalkthrogh2}
            extraComponents={actions}
          />
          <div style={{ backgroundColor: 'transparent' }} />
        </Slider>
      </div>
    </Modal>
  );
};

export default HomeView;
